const COLORS = Object.freeze({
  textColor: '#52555f',
  textColorOpacity: '#52555FB2',
  borderColor: '#e0e5eb',
  bgTableTitle: '#F5F6FB',
  activeColor: '#FF751D',
  greenColor: '#407946',
  backgroungColor: '#F6F7FB',
  blackColor: '#000000',
  whiteColor: '#FFFFFF',
  barColor: '#FFDAC0',
  redColorExpenses: '#E53935',
  greenColorIncoms: '#407946',
  redColor: '#E7192E',
  reportsIconBg: '#FFDAC0',
  redColorText: '#eb5757',
});

export default COLORS;
